const styles = {
    articleCard_container: {
        display: "block",
        width: "100%",
        height: "100%",
    },
    articleCard: {
        display: "block",
        overflow: "hidden",
    },
    articleCard__1x_2y: {
        height: "304px",
        width: "300px",
    },
    articleCard__2x_2y: {
        height: "304px",
        width: "612px",
    },
};
export default styles;
